<template>
	<div >
		<el-row>
			<el-col :span="24" class="notify-box" style="padding-left: 20px;">
				<div class="el-row">
					<icon name="bullhorn" scale="1.5" class="notify-icon"></icon>
					<span>最新公告：</span>
					<swiper
						:options="notifySwiperOption"
						class="notify-swiper"
						ref="notifySwiper"
						v-if="web.bulletins.length"
						@click.native="showBulletin"
						>
						<swiper-slide v-for="(bulletin, index) in web.bulletins" :key="index">{{bulletin.content}}</swiper-slide>
					</swiper>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<img src="~assets/images/live/ddad344999fbfcf914d673342b0e3b90154daa74.png" style="height: 310px;width: 100%;">
		</el-row>
		<el-row>
			<el-col class="lottery-bg" style="margin-bottom:20px">
				<div class="contentnav">
					<div class="img_open">
						<div class="img_open_box">
							<div>
								<img src="~assets/images/live/lottery_modal-1.5e69a1b.png" style="height: 609px;width: 605px;">
							</div>
							<div>
								<div>
									<img src="~assets/images/live/title.01cb6d3.png" style="height: 95px;">
								</div>
								<div style="width: 360px;font-size:20px;color: #787878;">
									NRC 公正做單平台提供各種高低頻彩票投注系列，所有彩票遊戲公正公開，皆參照各地官方開獎結果為依據，連線同步即時開彩。
								</div>
							</div>
						</div>
						<div>
							
							
						</div>
					</div>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<div class="shadow">
				<div class="s-z1 titleflex">
					<img src="~assets/images/live/lottery-open.f9f8f4c.png" >
				</div>
			</div>
		</el-row>
		<el-row>
			<div class="content_wrapper"><div class="content_5"><ul class="speed-box margin-top"><li class="speed-bg"><div class="speed-flex"><div class="value">
						60
						</div> <span class="speed-t3">秒</span></div> <div><div class="speed-t1">
						入款平均時間
						</div> <div class="speed-t2">
						deposit speed
						</div></div></li> <li class="speed-bg"><div class="speed-flex"><div class="value2">
						5
						</div> <span class="speed-t3">分鐘</span></div> <div><div class="speed-t1">
						託售平均時間
						</div> <div class="speed-t2">
						withdrawal speed
						</div></div></li> <li class="amount-bg"><div class="speed-flex"><div class="value3">
						98
						</div> <span class="speed-t3">家</span></div> <div><div class="speed-t1">
						合作支付銀行
						</div> <div class="speed-t2">
						payment cooperation
						</div></div></li> <li class="amount-bg"><div class="speed-flex"><div class="value4">
						24
						</div> <span class="speed-t3">家</span></div> <div><div class="speed-t1">
						合作遊戲平台
						</div> <div class="speed-t2">
						platform cooperation
						</div></div></li></ul> <ul class="speed-box2"><li><div class="speed-t1">
						信譽資金託管
					</div> <div class="speed-t3">
						MORE WAYS TO PROTECT
					</div> <div class="speed-t2 tleft">
						獨立開發，128位加密技術和嚴格的安全管理體系，讓客戶資金得到最完善的保障。
					</div></li> <li><div class="speed-t1">
						5分鐘出款
					</div> <div class="speed-t3">
						MORE WAYS TO WIN
					</div> <div class="speed-t2 tleft">
						最新技術自主研發的財務處理系統，極速存、取、轉。獨家網絡優化技術，為您提供一流的遊戲體驗。
					</div></li> <li><div class="speed-t1">
						三端數據互通
					</div> <div class="speed-t3">
						MORE DEVICES ACCOUNT
					</div> <div class="speed-t2 tleft">
						支持各種終端設備，完美兼容PC、移動端。原生態App讓您隨時隨地輕鬆投注。
					</div></li> <li><div class="speed-t1">
						賽事覆蓋全面
					</div> <div class="speed-t3">
						MORE EVENTS TO PLAY
					</div> <div class="speed-t2 tleft">
						每天提供超過500場不同類別的精彩賽事，涵蓋世界範圍內主要體育運動，讓客戶擁有最完美的遊戲體驗。
					</div></li></ul></div></div>
		</el-row>
		<el-row >
			<div class="content_6">
				<div class="qr-box"><div class="qrcode online"><div>LINE客服</div> <div class="col-login"><div class="online"><div>請點選以下按鈕</div> 
				<a @click="service()" style="cursor: pointer;">
				<img src="~assets/images/live/btn.2945b35.png" >
				</a></div>
				</div></div></div></div>			
		</el-row>
	<!-- <el-row>
		<el-col :span="12">
			<h3 style="padding-left: 20px;">{{ user.username }} 用戶資料
					<el-button type="text" @click="pwd()" class="btn-user"  >
						<span >[ 修改登錄密碼 ]</span>
					</el-button>
			</h3>
			<el-col style="display: inline-flex;padding-left: 20px;padding-bottom: 20px;font-size: 16px;">
				<div style="width: 50%;"><i class="fas fa-balance-scale" style="color:var(--icon-font-color)"></i> 未實現損益: {{ user.wallet.totalAmounts.toFixed(2) }}</div>
			</el-col>   
			<el-row style="padding-left: 20px;">
				<div style="font-size: 16px;line-height: 28px;">銀行帳戶</div>
				<div v-if="user.bank.bank_account" style="font-size: 16px;line-height: 28px;">
						銀行: {{user.bank.bank_value}}
						<br>
						戶名: {{user.bank.bank_username}}
						<br>
						帳號: {{user.bank.bank_account | markaccount}}
				</div>
				<div v-else>
					<el-button type="text" @click="go2page('/user/set-bank')" class="btn-user"  >
						<span >[ 綁定銀行帳戶 ]</span>
					</el-button>
				</div>
				<div>

				</div>
			</el-row>
			<el-row style="padding-left: 20px;padding-bottom: 20px;padding-top:30px">
				<el-col :span="12">
					<div @click="$router.push('/user/deposit');" style="cursor: pointer; margin-right:15px" class="icon-btn">
						<img src="~assets/images/icon/loan.png" style="height: 45px;"> <br>存款專區
					</div>
				</el-col>
				<el-col :span="12">
					<div @click="$router.push('/user/withdraw');" style="cursor: pointer;" class="icon-btn">
						<img src="~assets/images/icon/interest-rate.png" style="height: 45px;"> <br>提款專區
					</div>             
				</el-col>
			</el-row>
			<el-row style="padding-left: 20px;padding-bottom: 20px;">
				<el-col :span="12">
					<div @click="$router.push('/user/transfer-log');" style="cursor: pointer; margin-right:15px" class="icon-btn">
						<img src="~assets/images/icon/cash-flow.png" style="height: 45px;"> <br> 對帳單查詢</div>
				</el-col>
				<el-col :span="12">
					<div @click="$router.push('/user/bet-log');" style="cursor: pointer;" class="icon-btn">
						<img src="~assets/images/icon/stamp.png" style="height: 45px;"> <br> 演算查詢
					</div>
				</el-col>
			</el-row>
			<el-row style="padding-left: 20px;padding-bottom: 20px;">
				<el-col :span="12">
					<div @click="logout()" style="cursor: pointer; margin-right:15px" class="icon-btn">
						<img src="~assets/images/icon/risk.png" style="height: 45px;"> <br> 安全登出</div>
				</el-col>
				<el-col :span="12">
					<div @click="service()" style="cursor: pointer;" class="icon-btn">
						<img src="~assets/images/icon/accountant.png" style="height: 45px;"> <br>  聯絡客服</div>
				</el-col>
			</el-row>
		</el-col>
		<el-col :span="12">
			<el-row>
				<div class="hotGame" >
					<div class="clearfix mt10" >
						<div class="item" style="margin-top:15px">
							<div class="item-img cursor hoverToBig" @click="startGame('VIX','VIX');">
								<div class="live_ebg" style="width: 90%;">
									<img style="width: 450px;"
										class="cursor"
										src="~assets/images/live/NEXUS-2.jpg"
										>
								</div>
							</div>
						</div>
					</div>
				</div>					
			</el-row>			
			<el-row>
				<el-form label-width="90px" :inline="true">
					<h3 style="padding-left: 20px;">額度轉換</h3>

					<el-form-item label="轉出">
						<span class="tip-amount" v-if="transfer.out && user.wallet.deploy[transfer.out].amount >= 0">${{ displayAmount(transfer.out) || '0.00'  }}</span>
						<el-select placeholder="請選擇" v-model="transfer.out" @change="changeOut" :clearable="true">
							<el-option  v-for="item in transfer.outArray" :key="item.value" :label="item.label" :value="item.value" :disabled="user.wallet.deploy[item.value].amount?item.disabled:true">
								<span>{{ item.label }}</span>
								<span class="wallet-rmb-tag" v-if="['VG'].includes(item.value)">幣值1:5</span>
								<span class="select-right-amount">${{ displayAmount(item.value) || '0.00' }}</span>
							</el-option>
						</el-select>
						<div class="rmb-tip" v-if="['VG'].includes(transfer.out)"><i class="el-icon-info"></i> 轉出幣值1:5「轉出2元 = 轉入10元」</div>
					</el-form-item>

					<el-form-item label="轉入">
						<span class="tip-amount" v-if="transfer.in && user.wallet.deploy[transfer.in].amount >= 0">${{ displayAmount(transfer.in) || '0.00'}}</span>
						<el-select placeholder="請選擇" v-model="transfer.in" value-key="transfer.in" @change="changeIn" :clearable="true">
							<el-option  v-for="item in transfer.inArray" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
								<span >{{ item.label }}</span>
								<span class="wallet-rmb-tag" v-if="['VG'].includes(item.value)">幣值5:1</span>
								<span style="float: right; color: #8492a6; font-size: 14px">${{ displayAmount(item.value) || '0.00' }}</span>
							</el-option>
						</el-select>
						<div class="rmb-tip" v-if="['VG'].includes(transfer.in)"><i class="el-icon-info"></i> 轉入幣值5:1「轉出10元 = 轉入2元」</div>
					</el-form-item>


					<el-form-item label="金額">
						<el-input placeholder="請輸入金額" @keyup.enter.native="onSubmit" @keypress.native="$bet.onlyNumber()" v-model="transfer.amount" :value="transfer.amount" :clearable="true"></el-input>
					</el-form-item>
					<el-form-item style="margin-bottom:0px;">
						<el-button type="primary" @click="onSubmit" :loading="transfer.loading">確定轉帳</el-button>
					</el-form-item>
					<el-form-item style="">
						
					</el-form-item>
				</el-form>
			</el-row>

		</el-col>
	</el-row>

	<el-divider></el-divider>

		
    <el-row style="margin:20px">
	  <iframe scrolling="no" allowtransparency="true" frameborder="0" src="https://s.tradingview.com/embed-widget/forex-heat-map/?locale=zh_TW#%7B%22width%22%3A%22100%25%22%2C%22height%22%3A%22100%25%22%2C%22isTransparent%22%3Afalse%2C%22currencies%22%3A%5B%22EUR%22%2C%22USD%22%2C%22JPY%22%2C%22GBP%22%2C%22CHF%22%2C%22AUD%22%2C%22CAD%22%2C%22NZD%22%2C%22CNY%22%5D%2C%22frameElementId%22%3Anull%2C%22colorTheme%22%3A%22light%22%2C%22utm_source%22%3A%22tw.tradingview.com%22%2C%22utm_medium%22%3A%22widget_new%22%2C%22utm_campaign%22%3A%22forex-heat-map%22%7D" style="box-sizing: border-box; height: 250px; width: 100%;"></iframe>
    </el-row> -->


		<el-dialog
			title="系統公告"
			:visible.sync="notify.dialog"
			class="user-layout-dialog"
			:close-on-click-modal="false"
			>
			<el-row>
				<el-col>
					{{notify.title}}
					<p><pre>{{notify.detail}}</pre></p>
				</el-col>
			</el-row>
		</el-dialog>
		<TransferBox ref="TransferBox"></TransferBox>
	</div>
</template>

<script>
import TransferBox from "@/components/TransferBox";
import SlotGameUtil from "@/components/views/SlotGameUtil";
import DigitRoll from "@huoyu/vue-digitroll";
import { mapGetters } from "vuex";
export default {
  props: ["keys"],
  filters: {
    onlyDate: function (val) {
      return val.split(" ")[0];
    },
  },
  data() {
    return {
      transfer: {
        amount: "",
        out: "",
        outArray: [],
        in: "",
        inArray: [],
        loading: false,
      },
      today_total: 0,
      today_up: 0,
      today_down: 0,
      //slots:[{"id":1,"vendor":"AE","game_id":"1","game_name":"\u7334\u5bf6\u5bf6"},{"id":2,"vendor":"AE","game_id":"2","game_name":"\u7334\u5bf6\u5bf62"},{"id":3,"vendor":"AE","game_id":"4","game_name":"\u7206\u70b8\u7cd6"},{"id":4,"vendor":"AE","game_id":"7","game_name":"\u9b54\u947d"},{"id":5,"vendor":"AE","game_id":"3","game_name":"777"},{"id":6,"vendor":"AE","game_id":"15","game_name":"\u9f8d8"},{"id":7,"vendor":"AE","game_id":"5","game_name":"\u767c\u767c\u767c"},{"id":8,"vendor":"AE","game_id":"9","game_name":"\u8d85\u7d1a\u5de8\u661f"},{"id":9,"vendor":"AE","game_id":"11","game_name":"\u806f\u76df"},{"id":10,"vendor":"AE","game_id":"12","game_name":"\u5e78\u904b\u9ab0"},{"id":11,"vendor":"AE","game_id":"106","game_name":"\u9f8d\u738b"},{"id":12,"vendor":"AE","game_id":"13","game_name":"\u62db\u8ca18"},{"id":13,"vendor":"AE","game_id":"8","game_name":"\u7206\u70b8\u7cd62"},{"id":14,"vendor":"AE","game_id":"14","game_name":"\u5927\u718a\u8c93"},{"id":15,"vendor":"AE","game_id":"18","game_name":"\u9280\u6cb3\u760b\u7206"},{"id":16,"vendor":"AE","game_id":"10","game_name":"\u6416\u9322\u6a39"},{"id":17,"vendor":"AE","game_id":"22","game_name":"\u6d77\u6d0b\u4e16\u754c"},{"id":18,"vendor":"AE","game_id":"23","game_name":"\u74b0\u904a\u4e16\u754c"},{"id":19,"vendor":"AE","game_id":"19","game_name":"\u4e00\u8def\u767c"},{"id":20,"vendor":"AE","game_id":"16","game_name":"\u9f8d\u73e0"},{"id":21,"vendor":"AE","game_id":"17","game_name":"\u806f\u76df2"},{"id":22,"vendor":"AE","game_id":"20","game_name":"\u5916\u661f\u4eba"},{"id":23,"vendor":"AE","game_id":"25","game_name":"\u4e00\u672c\u842c\u5229"},{"id":24,"vendor":"AE","game_id":"27","game_name":"\u8239\u9577\u7684\u5bf6\u85cf"},{"id":25,"vendor":"AE","game_id":"24","game_name":"\u9ebb\u5c07"},{"id":26,"vendor":"AE","game_id":"28","game_name":"\u62db\u8ca1\u9032\u5bf6"},{"id":27,"vendor":"AE","game_id":"32","game_name":"\u5409\u7965\u5982\u610f"},{"id":28,"vendor":"AE","game_id":"26","game_name":"\u9b54\u6cd5\u7403"},{"id":29,"vendor":"AE","game_id":"37","game_name":"\u53e4\u602a\u7334\u5b50"},{"id":30,"vendor":"AE","game_id":"29","game_name":"\u4e94\u884c"},{"id":31,"vendor":"AE","game_id":"31","game_name":"\u8c50\u8ca1\u805a\u5bf6"},{"id":32,"vendor":"AE","game_id":"39","game_name":"\u5e74\u5e74\u6709\u9918"},{"id":33,"vendor":"AE","game_id":"38","game_name":"\u9b54\u947d2"},{"id":34,"vendor":"AE","game_id":"40","game_name":"\u7cd6\u679c\u760b\u7206"},{"id":35,"vendor":"AE","game_id":"6","game_name":"\u904b\u8ca1\u7ae5\u5b50"},{"id":36,"vendor":"AE","game_id":"42","game_name":"\u53e4\u602a\u7334\u5b505000\u500d"},{"id":37,"vendor":"AE","game_id":"41","game_name":"\u51b0\u4e0a\u66f2\u68cd\u7403"}],
      blog: [],
      notify: {
        dialog: false,
        title: "",
        detail: "",
        date: "",
      },
      swiperOption: {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        speed: 400,
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        mousewheelControl: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      swiperLive: {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        speed: 400,
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        mousewheelControl: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      notifySwiperOption: {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        speed: 400,
        direction: "vertical",
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        mousewheelControl: true,
        observer: true,
      },
    };
  },
  components: {
    SlotGameUtil: SlotGameUtil,
    TransferBox: TransferBox,
    DigitRoll: DigitRoll,
  },
  mounted() {
    setTimeout(() => {
      this.reset_today();
    }, 300);
  },
  filters: {
    markaccount: function (value) {
      if (!value) return "";
      if (value.length < 5) return "";
      let temp = value.substr(0, value.length - 5);
      //value = value.toString()
      return temp + "*****";
    },
  },
  computed: {
    ...mapGetters({
      config: "config",
      user: "user",
      web: "web",
    }),
    notifySwiper() {
      return this.$refs.notifySwiper.swiper;
    },
  },
  methods: {
    pwd() {
      console.log(111);
      this.$emit("Pwd", { methods: "pwd" });
    },
    transferSwitch() {
      //console.log(this.transfer.in,this.transfer.out);
      var tempArray = this.transfer.inArray;
      var tempValue = this.transfer.in;
      this.transfer.inArray = this.transfer.outArray;
      this.transfer.in = this.transfer.out;
      this.transfer.outArray = tempArray;
      this.transfer.out = tempValue;
    },
    changeOut(value) {
      //	console.log(value);
      //console.log('out:'+this.transfer.out);
      //console.log('in:'+this.transfer.in);
      for (var i = 0; i < this.transfer.inArray.length; i++) {
        this.transfer.inArray[i].disabled = false;
        if (this.transfer.inArray[i].value == value) {
          this.transfer.inArray[i].disabled = true;
        }
        if (value != "WALLET") {
          if (["VG"].includes(this.transfer.inArray[i].value)) {
            this.transfer.inArray[i].disabled = true;
          }
        }
        if (["VG"].includes(value)) {
          this.transfer.inArray[i].disabled = true;
          if (this.transfer.inArray[i].value == "WALLET") {
            this.transfer.inArray[i].disabled = false;
          }
        }
      }
    },
    changeIn(value) {
      for (var i = 0; i < this.transfer.outArray.length; i++) {
        this.transfer.outArray[i].disabled = false;
        if (this.transfer.outArray[i].value == value) {
          this.transfer.outArray[i].disabled = true;
        }
        if (value != "WALLET") {
          if (["VG"].includes(this.transfer.outArray[i].value)) {
            this.transfer.outArray[i].disabled = true;
          }
        }
        if (["VG"].includes(value)) {
          this.transfer.outArray[i].disabled = true;
          if (this.transfer.outArray[i].value == "WALLET") {
            this.transfer.outArray[i].disabled = false;
          }
        }
      }
    },
    onSubmit() {
      if (!this.transfer.out) {
        return this.$layer.msg("請選擇轉出帳戶");
      }
      if (!this.transfer.in) {
        return this.$layer.msg("請選擇轉入帳戶");
      }
      if (!this.transfer.amount || parseFloat(this.transfer.amount) < 1) {
        return this.$layer.msg("請輸入金額");
      }

      this.transfer.amount = parseFloat(this.transfer.amount);

      if (
        this.transfer.amount > this.user.wallet.deploy[this.transfer.out].amount
      ) {
        this.transfer.amount =
          this.user.wallet.deploy[this.transfer.out].amount;
        return this.$layer.msg(
          "金額不得大於" + this.user.wallet.deploy[this.transfer.out].amount
        );
      }

      this.transfer.loading = true;
      this.$axios({
        method: "POST",
        url: this.config.ApiUrl + "/api/transfer",
        data: {
          amount: this.transfer.amount,
          from: this.transfer.out,
          to: this.transfer.in,
        },
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          //console.log(response.data);
          this.$layer.msg(response.data.message);
          if (response.data.status) {
            this.user.wallet.deploy[this.transfer.out].amount =
              this.user.wallet.deploy[this.transfer.out].amount -
              parseFloat(this.transfer.amount);
            //this.user.wallet.deploy[this.transfer.in].amount = this.user.wallet.deploy[this.transfer.in].amount + parseFloat(this.transfer.amount);
            setTimeout(() => {
              this.refreshAll();
            }, 100);
            //this.transfer.amount = '';
          }
          this.transfer.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    refreshBalance(vendor) {
      //console.log(lastKey);
      this.$axios({
        method: "GET",
        url: this.config.ApiUrl + "/api/get-balance/" + vendor,
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          this.vendorsCount++;
          if (response.data.status) {
            //					this.user.wallet.deploy[vendor].amount = response.data.data.amount;
            let self = this;
            TweenLite.to(this.user.wallet.deploy[vendor], 0.5, {
              amount: response.data.data.amount,
              onComplete: function () {
                self.refreshPercents();
              },
            });
            //this.user.wallet.deploy[vendor].amount = parseFloat(response.data.data.amount);
            //this.refreshPercents();
            if (response.data.data.time) {
              this.user.wallet.sync = response.data.data.time;
            }
          }

          //console.log(this.vendorsCount);
          if (this.vendorsCount == this.user.vendorsCount) {
            //this.$layer.msg('刷新完成');
            this.vendorsCount = 0;
            this.buttonLoading = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    refreshPercents() {
      var totalAmounts = 0;
      this.user.wallet.totalAmounts = 0;

      for (var key in this.user.wallet.deploy) {
        totalAmounts += parseFloat(this.user.wallet.deploy[key].amount);
      }
      this.user.wallet.totalAmounts = totalAmounts;

      for (var key in this.user.wallet.deploy) {
        //this.user.wallet.deploy[key].percent = Math.round( parseFloat(this.user.wallet.deploy[key].amount) / totalAmounts * 100);
        this.user.wallet.deploy[key].percent =
          Math.floor(
            (parseFloat(this.user.wallet.deploy[key].amount) / totalAmounts) *
              10000
          ) / 100;
      }
    },
    displayAmount(args) {
      return parseFloat(this.user.wallet.deploy[args].amount).toFixed(2);
    },
    butClick(item) {
      window.open(item.url, "", "");
    },
    getBlog(page) {
      this.$axios({
        method: "GET",
        url:
          this.config.ApiUrl +
          "/api/blog2/" +
          this.config.company +
          "/?page=" +
          (page ? page : 1),
        data: {},
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (response.data) {
            this.blog = response.data.data;
            // this.form.currentPage = response.data.current_page;
            // this.form.total = response.data.total;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // getWin()
    // {
    // 	this.$axios({
    // 		method: "GET",
    // 		url: this.config.ApiUrl + "/api/win/" + this.config.company,
    // 		data: {},
    // 		headers: {
    // 		"Content-Type": "application/json"
    // 		}
    // 	})
    // 	.then(response => {
    // 	if (response.data) {
    // 		this.web.win = response.data;
    // 	}
    // 	})
    // 	.catch(error => {
    // 		console.log(error);
    // 	});
    // },
    getRandom(min, max) {
      return Math.floor(Math.random() * max) + min;
    },
    reset_today() {
      if (this.today_total == 0) {
        this.today_total = this.getRandom(30000000, 80000000);
      } else {
        this.today_total += this.getRandom(10, 500);
      }
      var num = this.getRandom(10, 70);
      this.today_up = num;
      this.today_down = 100 - num;
      setTimeout(() => {
        this.reset_today();
      }, 15000);
    },
    go2page(page) {
      console.log(page);
      this.$emit("HeaderMenu", page);
      this.$router.push(page);
    },
    moreMessage() {
      if (this.user.isLogin == false) {
        this.$emit("LoginBox", { methods: "login" });
        return false;
      }
      this.go2page("/user/mail");
    },
    startGame(source, id) {
      if (this.user.isLogin == false) {
        this.$emit("LoginBox", { methods: "login" });
        return false;
      }

      this.$refs.TransferBox.open(source, id);
    },
    tryGame(soruce, id) {
      this.$refs.SlotGameUtil.dialog = true;
      this.$refs.SlotGameUtil.stash.soruce = soruce;
      this.$refs.SlotGameUtil.stash.id = id;
    },
    showBulletin: function (index) {
      var index = this.notifySwiper.clickedSlide.getAttribute(
        "data-swiper-slide-index"
      );
      this.notify.detail = this.web.bulletins[index].content;
      this.notify.title = this.web.bulletins[index].title;
      this.notify.date = this.web.bulletins[index].start_time;
      this.notify.dialog = !this.notify.dialog;
    },
    syncBulletin() {
      this.$axios({
        method: "GET",
        url: this.config.ApiUrl + "/api/bulletin/" + this.config.company,
        data: {},
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (response.data) {
            this.web.bulletins = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    logout() {
      this.$emit("LoginBox", { methods: "logout" });
    },
    service() {
      window.open(
        this.config.CustomerServiceUrl,
        "",
        "height=500,width=500,location=no,menubar=no,menubar=no"
      );
    },
  },
  created() {
    if (!this.web.bulletins.length) {
      this.syncBulletin();
    }
    //this.getBlog(1);
    // if (!this.web.win.length) {
    //   this.getWin();
    // }
    // if (!this.user.wallet.refresh) {
    //   //this.refreshUserBalance();

    //   for (var key in this.config.vendors) {
    //     this.$set(this.user.wallet.deploy, this.config.vendors[key].value, {
    //       amount: 0,
    //       percent: 0,
    //     });
    //   }
    //   //console.log(this.user.wallet.deploy);
    //   for (var key in this.config.vendors) {
    //     this.refreshBalance(this.config.vendors[key].value);
    //   }
    //   this.user.vendorsCount = this.config.vendors.length;
    //   this.user.wallet.refresh = true;
    // }
    // for (var key in this.config.vendors) {
    //   this.transfer.outArray.push({
    //     value: this.config.vendors[key].value,
    //     label: this.config.vendors[key].label,
    //     icon: this.config.vendors[key].icon,
    //     disabled: false,
    //   });
    //   this.transfer.inArray.push({
    //     value: this.config.vendors[key].value,
    //     label: this.config.vendors[key].label,
    //     icon: this.config.vendors[key].icon,
    //     disabled: false,
    //   });
    // }

    // Object.assign({}, this.transfer.outArray);
    // Object.assign({}, this.transfer.inArray);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.blog-list {
  cursor: pointer;
}
.blog-list2 {
  background-color: #f9f9fa;
}
.today_number {
  text-align: center;
  background-color: #1c202e;
  padding-top: 15px;
  color: #ddd;
}
.d-roll-wrapper .d-roll-list .d-roll-item {
  width: 15px !important;
}
.box {
  background-image: radial-gradient(circle at 50% 22%, #d4fefe, #346291);
  font-size: 18px;
  text-align: center;
  padding: 10px;
  color: #666;
}
.home-page .about-box {
  margin-top: 10px;
  border: 1px solid #eaeaea;
  padding: 30px 30px;
  background-color: #fff;
  margin-bottom: 20px;
}
.home-page .about-box .left-content {
  float: left;
  width: 700px;
  line-height: 30px;
  font-size: 15px;
  color: #666;
}
.home-page .about-box .right-content {
  float: left;
  margin-left: 30px;
}
.home-page .about-box .right-content img {
  border: 1px solid #ddd;
  padding: 3px;
  width: 300px;
}

.plate .plate-content .plate-left .swiper .banner-img .rel {
  width: 506px;
  height: 366px;
}
.main-header {
  margin-top: 20px;
  overflow: hidden;
  position: relative;
}
.main-header .line-l {
  width: 4px;
  height: 18px;
  background: #e4bb7b;
  position: absolute;
  left: 0;
  margin-top: 3px;
}
.main-header .plus {
  color: #409eff;
}

.main-header .title {
  font-size: 18px;
  color: #ddd;
  margin-left: 9px;
}
.main-header .subTitle {
  color: #aaa;
  margin-left: 5px;
}
.main-header .more {
  float: right;
  margin-top: 3px;
  color: #6c6c6c;
  cursor: pointer;
  font-size: 14px;
}
.main-header .more .icon-more {
  width: 15px;
  height: 14px;
  display: inline-block;
  background: url(https://dandelionservice.com~assets/css/img/kuozhan.3856191.png)
    no-repeat;
  /*
  background-size: cover;*/
  margin-left: 3px;
  /*
  vertical-align: bottom;*/
  margin-bottom: -2px;
}
.plate .plate-content {
  margin-top: 10px;
}
.plate .plate-content .plate-left {
  width: 540px;
  height: 450px;
  float: left;
  margin-right: 5px;
}
.plate .plate-content .plate-left .swiper {
  position: relative;
  height: 100%;
}
.plate .plate-content .plate-left .swiper .swiper-container {
  height: 100%;
}
.plate .plate-content .plate-right {
  width: 565px;
  height: 450px;
  float: left;
}
.plate-item {
  width: 565px;
  height: 222px;
  float: left;
}
.plate-item .plate-item-img {
  width: 100%;
  height: 100%;
  position: relative;
}
.hoverToBig {
  overflow: hidden;
}
.cursor {
  cursor: pointer;
}

.plate-item .plate-item-img .abs,
.plate-item .plate-item-img .txt3 {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
}
.plate-item .plate-item-img .txt {
  width: 100%;
  text-align: center;
  position: absolute;
  bottom: 20px;
  font-size: 16px;
  z-index: 1;
}
.plate-item .plate-item-img .txt .txt1 {
  margin-bottom: 10px;
  color: #409eff;
}
.plate-item .plate-item-img .txt .txt2 {
  color: #fff;
}
.plate-item .plate-item-img .txt3 {
  z-index: 2;
  background: rgba(0, 0, 0, 0.8);
}
.plate-item .plate-item-img .txt3 .txt4 {
  padding: 30px 25px 0;
  color: orange;
  font-size: 16px;
}

.plate-item .plate-item-img .txt3 .button {
  display: flex;
  justify-content: center;
}
.plate-item .plate-item-img .txt3 .button .btn {
  font-size: 15px;
  padding: 5px 15px;
  border-radius: 2px;
}
.plate-item .plate-item-img .txt3 .txt5 {
  padding: 0 25px;
  margin-top: 10px;
  line-height: 25px;
  color: #fff;
  font-size: 15px;
  height: 80px;
}

.btn {
  display: inline-block;
  margin-bottom: 0;
  font-weight: 100;
  text-align: center;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  background-image: none;
  border: 1px solid transparent;
  white-space: nowrap;
  line-height: 1.5;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 14px;
  border-radius: 4px;
  transition: color 0.2s linear, background-color 0.2s linear,
    border 0.2s linear;
  color: #495060;
  background-color: #f7f7f7;
  border-color: #dddee1;
}
.btn {
  padding: 0 36px;

  color: #fff;
  background: #409eff;
  font-weight: 700;
  border: 1px solid #409eff;
}
.plate-item .plate-item-img .txt3 .button .btn.empty {
  margin-left: 35px;
  background: transparent;
}
.btn.empty {
  background: #fff;
  color: #409eff;
}

.plate-item .live-bg1 {
  background-image: url(~assets/images/live/allbet.jpg);
  background-size: cover;
  width: 100%;
  height: 100%;
}
.plate-item .live-bg2 {
  background-image: url(~assets/images/live/sa.jpg);
  background-size: cover;
  width: 100%;
  height: 100%;
}
.plate-item .live-bg3 {
  background-image: url(~assets/images/live/dg.jpg);
  background-size: cover;
  width: 100%;
  height: 100%;
}
.plate-item .live-bg4 {
  background-image: url(~assets/images/live/og.jpg);
  background-size: cover;
  width: 100%;
  height: 100%;
}
/* .plate-item .live-bg5 {
    background-image: url(~assets/images/live/home_banner1.jpg);
	background-size: cover;
    width: 100%;
    height: 100%;
} */
.plate-item .live-bg6 {
  background-image: url(~assets/images/live/unnamed.jpg);
  background-size: cover;
  width: 100%;
  height: 100%;
}

.plate-item .plate-item-img .txt3 .button .btn.empty {
  margin-left: 30px;
  background: transparent;
}
.plate-item:nth-child(2) {
  margin-left: 0px;
  margin-top: 5px;
}
.plate-item:nth-child(3) {
  margin-top: 5px;
}
.plate-item:nth-child(4) {
  margin-top: 5px;
  margin-left: 5px;
}
.my_animated {
  animation-duration: 0.5s;
  animation-fill-mode: both;
}
/*中間css*/
.plate3 .plate-left {
  /*width: 905px;*/
  display: inline-block;
  vertical-align: top;
}
.plate3 .hotGame {
  margin-top: 10px;
}
.mt10 {
  margin-top: 10px;
}
.plate3 .item {
  width: 821px;
  /*height: 310px;*/
  float: left;
}
.plate3 .hotGame .item-img {
  width: 100%;
  height: 100%;
}
.plate3 .item img {
  width: 100%;
  height: 100%;
}
.hoverToBig img {
  transition: transform 0.5s;
}
.ml5 {
  margin-left: 5px;
}
.plate3 .hotGame .item-img1:first-child {
  margin-right: 2px;
}
.plate3 .hotGame .item-img1 {
  width: 199px;
  height: 100%;
  display: inline-block;
}
.plate3 .hotGame .item-img1 > div {
  height: 100%;
}
.plate3 .plate-down {
  width: 282px;
  display: inline-block;
  margin-left: 5px;
}
.plate3 .plate-down .inform {
  border: 1px solid #eaeaea;
  height: 330px;
}
.win-info.main {
  padding: 0 20px;
  border-bottom: 1px solid #888;
  background: #2a323e;
}
.win-info {
  height: 40px;
  line-height: 40px;
  border-bottom: 1px dashed #eaeaea;
}

.hotGame #hotSwiper {
  margin-top: 0;
  border: 1px solid #eaeaea;
  width: 100%;
}
#hotSwiper {
  height: 120px;
  padding: 0 50px;
  background: #fff;
  margin-top: 20px;
}
.sport-list {
  border: 1px solid #888;
  height: 313px;
  margin-top: 10px;
  color: #ddd;
}
.cursor.marquee.marquee-li {
  padding: 7px 10px 0 10px;
  border-bottom: 1px dotted #eaeaea;
  height: 35px;
  position: relative;
  font-size: 100%;
  font: inherit;
  list-style-type: none;
  background-color: #333f56;
}

.plate-down-content > ul {
  padding-inline-start: 0;
}

.sport > .sport-right {
  padding-left: 20px;
}

.container-sport {
  height: 272px;
  overflow: hidden;
  background: #333f56;
  position: relative;
  box-sizing: border-box;
  padding: 10px;
  font-size: 14px;
}

.plate-down-content > .left-marquee {
  top: 6em;
  position: relative;
  box-sizing: border-box;
  animation: marquee 10s linear infinite;
  border-bottom: 1px solid #eaeaea;
}

.plate-down-content > .left-marquee:hover {
  animation-play-state: paused;
}

/* Make it move! */
@keyframes marquee {
  0% {
    top: 0em;
  }
  100% {
    top: -20em;
  }
}

.live_bg {
  transition: transform 0.5s;
  transform: scale(1);
}
.plate-item:hover .live_bg {
  transform: scale(1.2);
}

.hotGame .hoverToBig .live_ebg {
  transition: transform 0.5s;
  transform: scale(1);
}
.hotGame .hoverToBig:hover .live_ebg {
  transform: scale(1.2);
}

.plate-item .plate-item-img .txt3 {
  transition: all 0.5s ease !important;
  opacity: 0;
}
.plate-item:hover .plate-item-img .txt3 {
  opacity: 1;
}
</style>
<style>
.home-page .slot-swiper {
  border: 1px solid #eaeaea;
  background-color: #fff;
}
.home-page .slot-swiper .swiper-box {
  display: block;
  position: relative;
  height: 90px;
  padding: 10px;
}

.home-page .slot-swiper .small-image {
  float: left;
  width: 90px;
  height: 90px;
}
.home-page .slot-swiper .small-image img {
  border-radius: 10px;
}

.home-page .slot-swiper .text-box {
  float: left;
  width: 156px;
  padding-left: 10px;
}
.home-page .slot-swiper .text-box .name {
  color: #409eff;
  font-weight: 700;
  font-size: 16px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.home-page .slot-swiper .text-box .vendor {
  color: #666;
  font-size: 15px;
  margin-top: 8px;
  margin-bottom: 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.home-page .slot-swiper .text-box .play {
  border-radius: 20px;
  border: 1px solid #409eff;
  font-size: 14px;
  padding: 3px 8px;
  cursor: pointer;
  background-color: #409eff;
  color: #fff;
}
.home-page .slot-swiper .text-box .try {
  border-radius: 20px;
  border: 1px solid #409eff;
  font-size: 14px;
  padding: 3px 8px;
  cursor: pointer;
  color: #409eff;
}

.home-page .banner-top17 {
  background: url(~assets/images/promotion/home_banner_17.jpg) center center /
    cover;
}
.home-page .banner-top18 {
  background: url(~assets/images/promotion/home_banner_18.jpg) center center /
    cover;
}
.home-page .banner-top19 {
  background: url(~assets/images/promotion/home_banner_19.jpg) center center /
    cover;
}
.home-page .banner-top1 {
  background: url(~assets/images/promotion/Home_Banner_02.jpg) center center /
    cover;
}
.home-page .banner-top2 {
  background: url(~assets/images/promotion/Home_Banner_03.jpg) center center /
    cover;
}
.home-page .banner-top3 {
  background: url(~assets/images/promotion/Home_Banner_01.jpg) center center /
    cover;
}
/*
.home-page .banner-top4 {background: url(~assets/images/pricing/pricing-banner.jpg) center center / cover;}
.home-page .banner-top4 {background: url(~assets/images/sport/banner.jpg) center center / cover;}
.home-page .banner-top5 {background: url(~assets/images/lottery/banner.jpg) center center / cover;}
.home-page .banner-top6 {background: url(~assets/images/fisher/banner.jpg) center center / cover;}
*/
.home-page .slide-s1 {
  background-image: url(~assets/images/live/allbet.jpg);
}
.home-page .slide-s2 {
  background-image: url(~assets/images/live/sa.jpg);
}
.home-page .slide-s3 {
  background-image: url(~assets/images/live/og.jpg);
}
.home-page .slide-s4 {
  background-image: url(~assets/images/live/wm.jpg);
}
.home-page .slide-s5 {
  background-image: url(~assets/images/live/dg.jpg);
}
.home-page .slide-s7 {
  background-image: url(~assets/images/live/vix.jpg);
}

.home-page .slide-av {
  background-image: url(~assets/images/live/index.jpg);
}
.home-page .slide-s6 {
  background-image: url(~assets/images/chess/vg.jpg);
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue